(function () {
  const loadMoreBtns = document.querySelectorAll('.load-more-media-quick-read');

  if (loadMoreBtns.length === 0) {
    return;
  }

  loadMoreBtns.forEach((btn) => {
    let page = 1;
    const perPage = btn.getAttribute('data-per-page');
    const total = btn.getAttribute('data-total');
    const categoryId = btn.getAttribute('data-category-id');

    btn.addEventListener('click', function (event) {
      event.preventDefault();

      fetch(load_more_data.url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({
          nonce: load_more_data.nonce,
          locale: load_more_data.locale,
          page: page,
          perPage: perPage,
          total: total,
          categoryId: categoryId,
          action: 'more_media_quick_read'
        })
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.text();
        })
        .then((response) => {
          page += 1;
          btn.insertAdjacentHTML('beforebegin', response);

          if (page >= total) {
            btn.remove();
          } else {
            btn.disabled = false;
          }
        })
        .catch((error) => {
          console.error('Error:', error);
          btn.disabled = false;
        });

      btn.disabled = true;
    });
  });
})();
